import type { UnitStatus } from '../services/api';

export interface UnitSearchPanel
  extends angular.resource.IResourceClass<
    angular.resource.IResource<UnitStatus>
  > {
  getStatuses(
    success?: (resp: UnitStatus[]) => any,
    error?: (error: any) => any,
  ): angular.resource.IResource<UnitStatus[]>;
}

UnitSearchPanel.$inject = ['$resource'];

export function UnitSearchPanel($resource: angular.resource.IResourceService) {
  return $resource(
    '/api/',
    {},
    {
      getStatuses: {
        method: 'GET',
        url: '/api/unit/status',
        isArray: true,
        cache: true,
      },
    },
  ) as UnitSearchPanel;
}
